import { motion } from "framer-motion";
import AdminCard from "./AdminCard";

export default function StatCard({
  title,
  value,
  icon,
}) {
  return (
    <motion.div whileHover={{ scale: 1.03 }}>
      <AdminCard className="p-6">

        <div className="flex justify-between items-center">

          <div>

            <p className="text-gray-400">
              {title}
            </p>

            <h2 className="text-3xl font-bold text-white mt-2">
              {value}
            </h2>

          </div>

          <div className="text-3xl text-green-400">
            {icon}
          </div>

        </div>

      </AdminCard>
    </motion.div>
  );
}